import React from 'react'
import Artiste from 'components/blocks/Artiste';

const Dashboard = () => {
    const artisteArray = [
        {name:"Falz", occupation:"Musician", imageUrl:"/images/png/falz.png"},
        {name:"Ninola", occupation:"Musician", imageUrl:"/images/png/nini.png"},
        {name:"Patoranking", occupation:"Musician", imageUrl:"/images/png/pat.png"},
        {name:"Falz", occupation:"Musician", imageUrl:"/images/png/falz.png"},
        {name:"Ninola", occupation:"Musician", imageUrl:"/images/png/nini.png"},
        {name:"Patoranking", occupation:"Musician", imageUrl:"/images/png/pat.png"}
    ];
    return (
        <div className="row dashboard">
            <div className="w-100 mb-3" style={{paddingLeft:12}}>
                <h3 className="text--large text--black text-left">Following</h3>
            </div>
            {
                artisteArray.map( (artiste, index) => (
                    <div key={index} className="col-md-3">
                        <Artiste
                            name={artiste.name}
                            occupation={artiste.occupation}
                            imageUrl={artiste.imageUrl}/>
                    </div>
                ))
            }
        </div>
    )
}

export default Dashboard